import React, { useState } from 'react'
import { Link } from 'gatsby'
import { makeStyles } from '@material-ui/core/styles'
import { BottomNavigation, BottomNavigationAction } from '@material-ui/core'
import { Home, Computer, LibraryBooks } from '@material-ui/icons'
import Icons from './Icons'

const useStyles = makeStyles({
  root: {
    width: '100%',
    maxWidth: '100vw',
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 6,
    boxShadow:
      '0px 3px 1px -2px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px rgba(0, 0, 0, 0.2)',
  },
})

export default function SimpleBottomNavigation() {
  const classes = useStyles()
  const [value, setValue] = useState(0)

  return (
    <BottomNavigation
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue)
      }}
      showLabels
      className={classes.root}
    >
      <BottomNavigationAction
        component={Link}
        to="/"
        label="Home"
        icon={<Home />}
      />
      <BottomNavigationAction
        component={Link}
        to="/sport"
        label="Sport"
        icon={
          <Icons
            icon="sport"
            style={{
              fontSize: 24,
              marginBottom: '6px',
              marginRight: '6px',
            }}
          />
        }
      />
      <BottomNavigationAction
        component={Link}
        to="/in-play"
        label="In-Play"
        icon={
          <Icons
            icon="live"
            style={{
              fontSize: 24,
              marginBottom: '6px',
              marginRight: '6px',
            }}
          />
        }
      />
      <BottomNavigationAction label="Virtuals" icon={<Computer />} />
      <BottomNavigationAction
        component={Link}
        to="/my-bets"
        label="My Bets"
        icon={<LibraryBooks />}
      />
    </BottomNavigation>
  )
}
